// extracted by mini-css-extract-plugin
module.exports = {"block":"layout_block__15GIV","blockTeacher":"layout_blockTeacher__317XJ","videoContainer":"layout_videoContainer__2LEDv","containerText":"layout_containerText___EreJ"};